module.exports = __webpack_public_path__ + "img/card-billing-history-hover.95eefb5c.svg";